// extracted by mini-css-extract-plugin
export default {"container":"clear-chat-button_container__HDe6y","disabled":"clear-chat-button_disabled__Zrs0Y"};